
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Image } from 'react-bootstrap'
import { Link } from 'react-router-dom';
import { useLocation } from 'react-router';
//import NavDropdown from 'react-bootstrap/NavDropdown';
//import topbg from '../images/testbackground.png';
import httlogo from '../images/httcrop.png';
function NavbarComponent() {
    const location = useLocation(); //gets url path for navbar to know what is active

    return (
        <div>
            <Navbar fixed="top" expand="md" id="custom-nav" className="px-0">
                <Image
                    src={httlogo}
                    alt="background"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: window.innerWidth < 768 ? '110px' : '30px',
                        height: '75px',
                        zIndex: 3
                    }}
                />
                <Container fluid className="px-0">
                    <Navbar.Toggle aria-controls="basic-navbar-nav" />
                    <Navbar.Collapse id="basic-navbar-nav" className="justify-content-center m-auto">
                        <Nav>
                            <Nav.Link as={Link} to="/" className={location.pathname === '/' ? 'active-nav-link' : ''} id="custom-nav-element">Home</Nav.Link>
                            <Nav.Link as={Link} to="/about" className={location.pathname === '/history' ? 'active-nav-link' : ''} id="custom-nav-element">About</Nav.Link>
                            <NavDropdown title="Trucks" id="custom-nav-element">
                                <NavDropdown.Item as={Link} to="/peterbilt">
                                    Peterbilt
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/isuzu">
                                    Isuzu
                                </NavDropdown.Item>
                                <NavDropdown.Item as={Link} to="/custom-truck">
                                    Custom
                                </NavDropdown.Item>
                            </NavDropdown>
                            <Nav.Link as={Link} to="/services" className={location.pathname === '/history' ? 'active-nav-link' : ''} id="custom-nav-element">Services</Nav.Link>
                            <Nav.Link as={Link} to="/parts" className={location.pathname === '/history' ? 'active-nav-link' : ''} id="custom-nav-element">Parts</Nav.Link>
                            <Nav.Link as={Link} to="/contact" className={location.pathname === '/history' ? 'active-nav-link' : ''} id="custom-nav-element">Contact</Nav.Link>
                        </Nav>
                    </Navbar.Collapse>
                </Container >
            </Navbar>
            <div style={{
                height: '75px',
            }} />

        </div>
    );
}

export default NavbarComponent;